export default __webpack_public_path__ + "static/media/img-0693-san-marino-full-face.8fde2865.png";